import QueryParamBuilder from './../utils/query-param-builder';
export default function FilterUtils(app) {
	app.factory('QueryParamFactory', [function () {
		return {
			getInstance: function () {
				return new QueryParamBuilder();
			}
		};
	}]);
}
